import { MantineProvider } from '@mantine/core';
import { MantineReactTable } from 'mantine-react-table';

const TableDetail = ({ columns, data }) => {
  return (
    <MantineProvider>
      <MantineReactTable
        columns={columns}
        data={data}
        enableStickyHeader
        enablePagination={false}
        mantineTableContainerProps={{
          style: { maxHeight: '500px', minHeight: '200px', width: '100%' },
        }}
      />
    </MantineProvider>
  );
};

export default TableDetail;
